export default function initPageInteractionHandler(config = {}) {
	if (typeof config !== 'object') {
		return false;
	}

	const _this = this;
	let interactionTriggered = false;
	const supportsPointer = window.PointerEvent != null;
	const formElementEvents = ['click', 'keydown', 'mousedown', 'touchstart'];
	if (supportsPointer) {
		formElementEvents.push('pointerdown');
	}
	const eventTypes = ['scroll', ...formElementEvents];
	const eventOptions = { passive: true, once: true };
	const $form = this?.$form || document.querySelector('form');
	const $currentStep = $form?.querySelector('.step--active');
	const $formButton = $form?.querySelector('.btn--primary');
	const $formRadios = $currentStep?.querySelectorAll('input[type="radio"]');
	const controller = new AbortController();
	const signal = controller.signal;
	const extraQuestionBlockTriggers = [
		{ name: 'HVACProjectScope', value: 'Repair' },
		{ name: 'NumberOfWindows', value: '1' }
	];

	const handleInteraction = function() {
		if (!interactionTriggered) {
			eventTypes.forEach(eventType => {
				document.removeEventListener(eventType, handleInteraction, eventOptions);
			});

			interactionTriggered = true;
			window?.modUtils?.lazyLoadScripts.call(_this, config);
			const scriptLoadStartEvent = new CustomEvent('lazyScript.load.start');
			document.dispatchEvent(scriptLoadStartEvent);
		}
	};

	eventTypes.forEach(eventType => {
		document.addEventListener(eventType, handleInteraction, eventOptions);
	});

	const isStepValid = function(isRadioButtonClick = false) {
		const $currentStepFields = $currentStep?.querySelector('.step__fields');
		const $extraQuestionBlock = $currentStep?.querySelector('.step__extra');
		const $currentStepInputs = $currentStep?.querySelectorAll('input[required],input[data-required]') || [];
		let showExtraQuestionBlock = false, isExtraBlockOptionSelected = false, $extraBlockSelectedOptions = [];
		let isValid = true, isExtraBlockValid = true;
		let $formGroup = null;
		$currentStepInputs?.forEach(($input) => {
			$formGroup = $input.closest('.form-group');

			if ($input?.type === 'radio') {
				const $currentStepFieldRadios = $currentStepFields?.querySelectorAll(`input[type="radio"][name="${$input.name}"]`);
				const $extraBlockRadios = $extraQuestionBlock?.querySelectorAll(`input[type="radio"][name="${$input.name}"]`);
				if ($currentStepFieldRadios && $currentStepFieldRadios.length) {
					const $selectedOptions = $currentStepFields.querySelectorAll(`input[type="radio"][name="${$input.name}"]:checked`);
					isValid = $selectedOptions.length;
					if ($selectedOptions.length) {
						$selectedOptions.forEach(($option) => {
							isExtraBlockOptionSelected = $option?.closest('.step__extra');
							if (!isExtraBlockOptionSelected) {
								showExtraQuestionBlock = extraQuestionBlockTriggers.some((trigger) => {
									return trigger.name === $option.name && trigger.value === $option.value;
								});
							}
						});
					}
				}

				if ($extraBlockRadios && $extraBlockRadios.length) {
					if (showExtraQuestionBlock) {
						$extraQuestionBlock.style.display = 'block';
						$extraBlockSelectedOptions = $extraQuestionBlock.querySelectorAll('input[type="radio"]:checked');
						isExtraBlockValid = $extraBlockSelectedOptions?.length > 0;
					} else {
						$extraQuestionBlock.style.display = 'none';
					}
				}
				isValid = isExtraBlockValid;
			} else if ($input?.type === 'checkbox') {
				isValid = $currentStep.querySelectorAll(`input[type="checkbox"][name="${$input.name}"]:checked`).length;
			} else {
				const valueLength = $input.value.trim().length;
				const maxLength = $input.getAttribute('maxlength');

				if (maxLength) {
					isValid = valueLength && valueLength <= Number(maxLength);
				} else {
					isValid = valueLength > 0;
				}
			}
		});

		if (!isValid) {
			if (!isRadioButtonClick) {
				$formGroup?.classList.add('has-error');
			}
			return false;
		}

		$formGroup?.classList.remove('has-error');

		return isValid;
	};

	const formElementEventsCallback = function(e, isRadioButtonClick = false) {
		if (window.homeOwnerScriptLoaded) {
			controller.abort();
			return;
		}

		if (!isRadioButtonClick) {
			e.preventDefault();
		}

		e.stopImmediatePropagation();

		if (!isStepValid(isRadioButtonClick)) {
			return;
		}

		window.interactedWithFormElement = true;
		$form?.classList.add('form--loading');
		handleInteraction(e);
	};

	formElementEvents.forEach(eventType => {
		$formButton?.addEventListener(eventType, function(e) {
			formElementEventsCallback(e);
		}, { signal: signal, passive: false });

		$formRadios?.forEach(($radio) => {
			$radio.addEventListener(eventType, function(e) {
				window.clickedRadioButton = $radio;
				formElementEventsCallback(e, true);
			}, { signal: signal, passive: false });
		});
	});
}
